import { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { toast } from "react-toastify";
import api from "../api";

function EditPrompt({
  nameEdit,
  descriptionEdit,
  idEdit,
  closeEditAgent,
  setRefresh,
  xCloseEditAgent,
}: any) {
  const [name, setName] = useState(nameEdit);
  const [description, setDescription] = useState(descriptionEdit);

  const handlePromptChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const handleEditSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("id", idEdit);
    formData.append("prompt_text", description);
    formData.append("prompt_name", name);

    try {
      await api.post(
        `${process.env.REACT_APP_USER_PROMPT_UPDATE}${idEdit}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setRefresh((prevRefresh: any) => prevRefresh + 1);
      toast.success("Business Rule has been edited successfully!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        theme: "dark",
      });
    } catch (error) {
      toast.error("An error occurred while updating the Business Rule", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        theme: "dark",
      });
      console.log(error);
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-md"
      onClick={closeEditAgent}
      role="button"
    >
      <div className="bg-white p-4 relative rounded shadow-2xl max-h-[95%] overflow-y-scroll">
        <button
          onClick={xCloseEditAgent}
          className="text-[25px] bg-[#4D30B5] hover:bg-[#1b1436] duration-300 rounded-lg p-1 text-white absolute top-2 right-2"
        >
          <RxCross2 size={25} className="-mt-[1px]" />
        </button>

        <p className="text-[25px] text-center content-center">
          Edit Business Rule
        </p>

        <form onSubmit={handleEditSubmit} className=" md:w-[750px] w-[350px]  ">
          <div className="p-4 flex flex-col gap-4 max-h-[650px] overflow-y-scroll">
            <div className=" flex flex-col ">
              <label className="pb-2 text-[20px]">Name:</label>
              <input
                required
                type="text"
                value={name}
                onChange={handlePromptChange}
                className=" border-[2px] text-black  outline-none p-1 rounded-lg"
              />
            </div>

            <div className=" flex flex-col ">
              <label className="pb-2 text-[20px]">Business Rule:</label>
              <pre>
                <code>
                  <textarea
                    required
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    className="border-[2px] text-black rounded-lg outline-none p-1 resize-none h-[400px] custom-scrollbar-chat w-full"
                  />
                </code>
              </pre>
            </div>
          </div>
          <div className="mt-4 flex justify-center">
            <button
              type="submit"
              className="bg-[#4D30B5] hover:bg-[#1b1436] text-white px-5 py-3 rounded duration-300"
            >
              Edit Business Rule
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
export default EditPrompt;
